import { useDispatch } from 'react-redux';
import { Link } from 'foundations-components/transitional/components/Link';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { updateParams } from 'FormsUI/actions/ReactRouter';
import { usePopover } from 'FormsUI/components/dashboard/frameworkTable/OpenPopoverProvider';

//@ts-expect-error CollectedForms missing types
import CollectedFormSidePanel from 'FormsUI/components/dashboard/panels/CollectedFormSidePanel';
import { VIEW_COLLECTED_FORM_DETAILS } from 'FormsUI/constants/TrackingInteractionKeys/Dashboard/Actions';
import { jsx as _jsx } from "react/jsx-runtime";
const ViewNonHubSpotInformationAction = ({
  formId,
  trackAction,
  children = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "dashboard.table.collectedForms.actions.viewInformation"
  })
}) => {
  const dispatch = useDispatch();
  const {
    showPopover,
    hidePopover
  } = usePopover();
  const onClose = () => {
    hidePopover();
  };
  const Popover = /*#__PURE__*/_jsx(CollectedFormSidePanel, {
    guid: formId,
    onClose: onClose
  });
  const onClick = () => {
    trackAction(VIEW_COLLECTED_FORM_DETAILS);
    dispatch(updateParams({
      collectedFormsId: formId
    }));
    showPopover(Popover);
  };
  return /*#__PURE__*/_jsx(Link, {
    onClick: onClick,
    "data-test-id": "view-non-hubspot-information-action",
    "data-action": "information",
    children: children
  });
};
export default ViewNonHubSpotInformationAction;